import {createBrowserRouter} from 'react-router-dom'
import PrivateRoute from '@route-guards/private-route/PrivateRoute.tsx'
import PublicRoute from '@route-guards/public-route/PublicRoute.tsx'
import PublicLayout from '@layouts/public-layout/PublicLayout.tsx'
import PrivateLayout from '@layouts/private-layout/PrivateLayout.tsx'
import {routes} from '@utilities/constants'
import SharedRoute from '@route-guards/shared-route/SharedRoute.tsx'
import SharedLayout from './layouts/shared-layout/SharedLayout'
import Ops from './components/commons/Ops'

const router = createBrowserRouter(
	[
		{
			element: <PrivateRoute />,
			errorElement: <Ops />,
			children: [
				{
					element: <PrivateLayout />,
					children: [
						{...routes.CLINICALINFO},
						{...routes.SYMPTOMS},
						{...routes.FINISHED},
						{...routes.CODEASSIGNED},
						{...routes.CODE},
						{...routes.ENTERED_INFORMATION},
						{...routes.TRIAGE_CONCLUDED},
						{...routes.FEEDBACK}
					]
				}
			]
		},

		{
			element: <PublicRoute />,
			errorElement: <Ops />,
			children: [
				{
					element: <PublicLayout />,
					children: [{...routes.ONBOARDING}]
				}
			]
		},

		{
			element: <SharedRoute />,
			errorElement: <Ops />,
			children: [
				{
					element: <SharedLayout />,
					children: [{...routes.PRIVACY}, {...routes.TERMS}]
				}
			]
		},

		{...routes.NOTFOUND}
	],
	{
		basename: '/'
	}
)

export default router
